module.exports = __webpack_public_path__ + "static/media/cscc-1.63ce0dfe.jpg";